/*
 * @Description: file content
 * @Author: sizhanhe
 * @Date: 2024-05-08 14:35:28
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-07 11:21:16
 */
import { defineStore } from 'pinia'
import { EAuthority, EIntelligentType, ELanguage, EMessageType } from '../constant'
import { ERangeType, createHistory, createSession, getFileSummary } from '../api'
import type { IFileSummary, TAssistantCpnProps } from '../types'
import type { IOpenCommon } from './index'
import { assistantListStore, historyListStore } from './index'
import { useWorkspaceStore } from '@/store'

export interface PreQuestionConfig {
  question: string
  businessId: number
  businessName: string
  realQuestion?: string
  isDigest?: boolean
  digest?: string
  fileRangeName?: string
  type?: number
  model?: number | null // 模型 null: beautyGPT; 8: R1
}

export type TCurrentFindFile = {
  isDigest?: boolean
  digest?: string
} & TAssistantCpnProps['findFileInfo'] | null

export const asstStore = defineStore('asstStore', () => {
  const workspaceStore = useWorkspaceStore()
  const currentWorkspace = computed(() => {
    return workspaceStore.currentWorkspace
  })

  const tabValue = ref<EAuthority>(EAuthority.ASSISTANT)
  const currentAuthority = ref<EAuthority>()

  const replyLanguage = ref<ELanguage>(ELanguage.ZH)

  const loadingMessage = ref<boolean>(false)

  interface IChatConfig {
    currentSession: 215 | 216 | 0
    historyID: string
    currentType: EIntelligentType
    sessionID: string
    fileID: number | null
    fileName: string | ''
    fileInfo: IFileSummary | null
    currentFindFile: TCurrentFindFile
    currentPreQuestion: PreQuestionConfig | null
    model?: number | null // 模型 null: beautyGPT; 8: R1
  }
  const chatConfig = reactive<IChatConfig>({
    currentSession: 0,
    historyID: '',
    currentType: EIntelligentType.GLOBAL,
    sessionID: '',
    fileID: null,
    fileName: '',
    fileInfo: null,
    currentFindFile: null,
    currentPreQuestion: null,
    model: 8,
  })

  function resetChatConfig() {
    chatConfig.currentSession = 0
    chatConfig.historyID = ''
    chatConfig.currentType = EIntelligentType.GLOBAL
    chatConfig.sessionID = ''
    chatConfig.fileID = null
    chatConfig.fileName = ''
    chatConfig.fileInfo = null
    chatConfig.currentFindFile = null
    chatConfig.currentPreQuestion = null
    chatConfig.model = 8 // 默认选中ds-r1
  }

  // 存储原料建议发送参数
  const materialParams = ref<any>(null)
  function setMaterialSuggestion(params: any) {
    materialParams.value = params
  }
  function resetMaterialSuggestion() {
    materialParams.value = null
  }

  // 存储找资料发送参数
  const findFileParams = ref<any>(null)
  function setFindFile(params: any) {
    findFileParams.value = params
  }
  function resetFindFile() {
    findFileParams.value = null
  }

  // 存储自由问答发送参数
  const prePromptParams = ref<any>(null)
  function setPrePrompt(params: any) {
    prePromptParams.value = params
  }
  function resetPrePrompt() {
    prePromptParams.value = null
  }

  function setupGlobal(config?: IOpenCommon) {
    console.log(config, 'config', materialParams.value, 'materialParams')
    const { addMessage, asstMessageList } = assistantListStore()
    // 防止重复的发送 打招呼的信息
    if (!asstMessageList.length) {
      const addMessageType = config?.preInstalledType === 'material' ? EMessageType.PREINSTALLED_MATERIAL : config?.preInstalledType === 'findFile' ? EMessageType.PREINSTALLED_FIND_FILE : config?.preInstalledType === 'question' ? EMessageType.PREINSTALLED_QUESTION : EMessageType.PREINSTALLED
      addMessage(addMessageType)
    }

    // addMessage(EMessageType.PREINSTALLED)
    // console.log(asstMessageList, 'asstMessageList')

    const sessionID = (config?.findFileInfo || config?.preQuestionConfig || findFileParams.value || (prePromptParams.value && prePromptParams.value.scoped)) ? 216 : 215
    chatConfig.currentSession = sessionID

    if (sessionID === 216) {
      loadingMessage.value = true
    }

    Promise.allSettled([newHistory(), newSession(sessionID)]).then(() => {
      const listStore = assistantListStore()

      if (config?.findFileInfo) {
        listStore.handleFindFile(config.findFileInfo)
      }

      if (config?.preQuestionConfig) {
        chatConfig.currentPreQuestion = config.preQuestionConfig
        listStore.fetchReply(config.preQuestionConfig.question, config.preQuestionConfig.realQuestion)
      }

      if (config?.prePrompt) {
        listStore.fetchReply(config.prePrompt)
      }

      // 从首页过来
      if (materialParams.value) {
        listStore.handleMaterial(materialParams.value)
      }
      if (findFileParams.value) {
        listStore.handleFindFile(findFileParams.value)
      }
      if (prePromptParams.value && !prePromptParams.value.scoped) {
        // console.log('111')
        // 没有选中
        listStore.fetchReply(prePromptParams.value.message)
      } else if (prePromptParams.value) {
        // console.log('prePromptParams', prePromptParams)
        // 选中了知识库或从首页点了提示问题过来
        const preQuestionConfig = {
          question: prePromptParams.value.message,
          businessId: prePromptParams.value.businessId,
          businessName: prePromptParams.value.scopedLabel,
          fileRangeName: prePromptParams.value.pathValues.map(item => item.label).join('-'),
          type: prePromptParams.value.scoped === -1 ? ERangeType.BASES : prePromptParams.value.pathValues.length === 2 ? ERangeType.BASE : ERangeType.FOLDER,
          model: prePromptParams.value.model, // 模型 null: beautyGPT; 8: R1
        }
        chatConfig.currentPreQuestion = preQuestionConfig
        listStore.fetchReply(prePromptParams.value.message, prePromptParams.value.contentGpt)
      }
    })
  }

  async function setupFile(fileID: number, fileName: string, question?: string) {
    chatConfig.fileID = fileID
    chatConfig.fileName = fileName

    const res = await getFileSummary({ fileId: fileID })
    if (res) {
      const { addMessage } = assistantListStore()
      addMessage(EMessageType.PRE_FILE, { suggestIssue: res.suggestIssue })
    }
    chatConfig.fileInfo = res

    chatConfig.currentSession = 216
    Promise.allSettled([newHistory(), newSession(216)]).then(() => {
      const { fetchReply } = assistantListStore()
      if (question?.trim()) {
        fetchReply(question || '')
      }
    })
  }

  // 设置历史ID
  async function newHistory() {
    await createHistory<string>({ title: 'new chat' }).then((res) => {
      chatConfig.historyID = res
    })
  }

  // 设置会话ID
  async function newSession(sceneId: number) {
    await createSession<string>({
      sceneId,
      sessionName: '',
      paramList: [],
    }).then((res) => {
      chatConfig.sessionID = res
    })
  }

  function reset() {
    resetChatConfig()

    const listStore = assistantListStore()
    tabValue.value = EAuthority.ASSISTANT
    listStore.reset()

    historyListStore().reset()
    resetMaterialSuggestion()
    resetFindFile()
    resetPrePrompt()
  }

  return {
    setupGlobal,
    reset,
    setupFile,
    newSession,
    currentWorkspace,
    chatConfig,
    tabValue,
    currentAuthority,
    loadingMessage,
    replyLanguage,
    setMaterialSuggestion,
    setFindFile,
    setPrePrompt,
  }
})
